var motykaD = require('./../distances/motyka');

module.exports = function motyka(a, b) {
    return 1 - motykaD(a,b);
};



// WEBPACK FOOTER //
// ./node_modules/ml-distance/src/similarities/motyka.js